/**
 * @generated SignedSource<<895a3eae03ef8537f7675ab5323c0a26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type OrderStatusType = "ClosedByAdmin" | "HasBillingDetails" | "HasCart" | "HasPaymentDetails" | "PaymentInProcess" | "PaymentReceived" | "Purchased" | "PurchasedAwaitingAccount" | "Transient";
export type PaymentMethodType = "Card" | "Giropay" | "IapApple" | "IapGoogle" | "InvoicePartner" | "InvoiceTk" | "Klarna" | "MonthlyPartner" | "MonthlyTk" | "Paypal" | "Sepa" | "Sofort";
export type PaymentProviderDataKind = "Apple" | "Default" | "Paypal" | "Sepa" | "Stripe" | "StripeSepa";
import { FragmentRefs } from "relay-runtime";
export type paymentProviderLink_OrderFragment$data = {
  readonly paymentData: {
    readonly dataType: PaymentProviderDataKind;
    readonly payerId?: string | null;
    readonly paymentIntentId?: string;
    readonly paymentMethod: PaymentMethodType;
  } | null;
  readonly selectedPaymentMethod: {
    readonly paymentMethodType: PaymentMethodType;
  } | null;
  readonly status: OrderStatusType;
  readonly " $fragmentType": "paymentProviderLink_OrderFragment";
};
export type paymentProviderLink_OrderFragment$key = {
  readonly " $data"?: paymentProviderLink_OrderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"paymentProviderLink_OrderFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "paymentIntentId",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "paymentProviderLink_OrderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "paymentData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentMethod",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dataType",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "StripePaymentProviderData",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "StripeSepaPaymentProviderData",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "payerId",
              "storageKey": null
            }
          ],
          "type": "PaypalPaymentProviderData",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "selectedPaymentMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentMethodType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};
})();

(node as any).hash = "06bab919883f18933929d2a5317029eb";

export default node;
